import { faBullseye, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext } from 'react'
import AppContext from '../contexts/AppContext';

export default function ModelItem({ model, onClick, selectedModel, alt, onDelete }) {
  const { openModal } = useContext(AppContext);

  return (
    <div onClick={onClick} className={`cursor-pointer`}>
      <div className={`p-4 border ${selectedModel == model ? 'border-teal-700/40 border-4' : 'border-slate-300 border-b-2'}  flex flex-col bg-white rounded-lg`}>
        {
          onDelete && selectedModel?.name === model.name &&
          <div className='text-lg col-span-1 flex justify-end items-center text-white uppercase'>
            <div onClick={
              () => openModal("Delete Schema?",
                `Are you sure you want to delete "${model.name}"`,
                () => { onDelete(model.name) }
              )
            } className='w-8 h-8 rounded-lg flex justify-center items-center bg-red-500'>
              <FontAwesomeIcon icon={faTrashAlt} size={'1x'} />
            </div>
          </div>
        }
        {alt && <p className='font-dmsans text-lg font-bold'>Prioritization Model</p>}
        <div className='mt-2'>
          <p className='font-dmsans text-2xl font-extrabold'>{model?.name}</p>
          {!alt && <p className='font-dmsans text-slate-400 text-sm mt-2'>{model?.id}</p>}
        </div>
        <div className='my-3 flex-col '>
          {
            alt &&
            <div className='mb-3 mt-1 font-semibold'>Criteria</div>
          }
          <div className='grid grid-cols-2 items-center justify-start text-slate-700 gap-2 mb-5'>
            {
              model?.schema.map((sch) => (
                <div style={{fontFamily: 'RobotoCondensed'}} className='truncate'>
                  <FontAwesomeIcon icon={faBullseye} className='mr-1' /> {sch.criteria}
                </div>
              ))
            }
          </div>


          <div className='flex flex-col gap-2'>
            <p className='flex text-sm bg-teal-100 text-teal-700 rounded-lg p-1 items-center justify-center'>
              {model?.createdBy}
            </p>
            {
              (model?.lastModifiedAt || model?.createdAt) &&
              <p className='flex text-sm mt-2'>
                Last Modified | {model.lastModifiedAt ? model.lastModifiedAt[2] : model.createdAt[2]}/{model.lastModifiedAt ? model.lastModifiedAt[1] : model.createdAt[1]}/{model.lastModifiedAt ? model.lastModifiedAt[0] : model.createdAt[0]}
              </p>
            }
          </div>
        </div>
      </div>
    </div >
  )
}
